import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

/**
 * Lara ya usa esmeralda como primary; forzamos tokens del datepicker para que
 * no queden colores “azul sistema” por resolución de variables u orden de carga.
 */
export const HcmPrimengPreset = definePreset(Lara, {
  components: {
    datepicker: {
      panel: {
        borderRadius: '1rem',
      },
      date: {
        borderRadius: '0.625rem',
        width: '2.25rem',
        height: '2.25rem',
        selectedBackground: '{primary.600}',
        selectedColor: '#ffffff',
        rangeSelectedBackground: 'color-mix(in srgb, {primary.500}, transparent 82%)',
        rangeSelectedColor: '{primary.800}',
      },
      colorScheme: {
        light: {
          date: {
            hoverBackground: '{surface.100}',
            color: '{surface.700}',
            selectedBackground: '#059669',
            selectedColor: '#ffffff',
          },
        },
        dark: {
          date: {
            hoverBackground: '{surface.800}',
            color: '{surface.0}',
            selectedBackground: '#10b981',
            selectedColor: '#ffffff',
          },
          panel: {
            background: '{surface.900}',
            borderColor: '{surface.700}',
            color: '{surface.0}',
          },
        },
      },
    },
  },
});
